import { Component, Output, ViewChild, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DataNewUser } from '../interface/add-user.interface';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ModalAddComponent } from '../modal-add/modal-add.component';
import { AddUsersService } from '../../service/add-users.service';
import { ModalEditComponent } from '../modal-edit/modal-edit.component';

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.scss'],
})
export class AddUsersComponent {
  displayedColumns = ['name', 'rut', 'progress', 'color'];
  dataSource: MatTableDataSource<DataNewUser>;
  dataUser: DataNewUser[] = [];  
  @Output() changeComponent = new EventEmitter<boolean>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);

  ngOnInit(): void {
    console.log(this.getUser());
  }

  constructor(
    public breakpointObserver: BreakpointObserver,
    private user: AddUsersService,
    private dialog: MatDialog
  ) {
    breakpointObserver.observe(['(max-width: 600px)']).subscribe((result) => {
      this.displayedColumns = result.matches
        ? ['firstName','email',  'phone', 'roles', 'rut','icon']
        : ['firstName','email',  'phone', 'roles', 'rut','icon'];
    });
    this.getUser();
    this.dataSource = new MatTableDataSource(this.dataUser);
  }
  getUser() {
    this.user.getUser().subscribe((e) => {
      console.log(e);      
      this.setDataSource(e);
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  private setDataSource(dataSource: Array<DataNewUser>) {
    this.dataSource = new MatTableDataSource<DataNewUser>(dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openHeaderDialog() {
    const dialogRef = this.dialog.open(ModalAddComponent);
    dialogRef.afterClosed().subscribe((result) => {
      this.changeComponent.emit(result);
    });
  }
  openEditDialog(id:string) {    
    const dialogRef = this.dialog.open(ModalEditComponent,{
      data: id
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.changeComponent.emit(result);
    });
  }

  delete(id:string) {
    Swal.fire({
      title: 'Deseas eliminar a este usuario?',
      text:`${id}`,
      showDenyButton: true,
      showCancelButton: true,
      denyButtonText: `Eliminar`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.fire('Saved!', '', 'success');
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
      }
    });
  }
}
